import { useCallback, useMemo } from 'react'
import { usePanelActions } from 'routes/layouts/hooks/usePanelActions'
import { useMemberOf, useMyUserId, useTownsContext, useUserLookup } from 'use-towns-client'

export const useMutualTowns = (userId: string | undefined, max: number = 5) => {
    const myUserId = useMyUserId()
    const memberOf = useMemberOf(userId)
    const { spaces } = useTownsContext()
    const user = useUserLookup(userId ?? '')

    const { mutualTowns, showMoreNum, numMutualTowns } = useMemo(() => {
        const all = spaces.filter((s) => (memberOf ? s.id in memberOf : false))
        const mutualTowns = all.slice(0, all.length <= max ? all.length : max - 1)
        const showMoreNum = all.length - mutualTowns.length
        return { mutualTowns, showMoreNum, numMutualTowns: all.length }
    }, [max, memberOf, spaces])

    const membersText = useCallback(() => {
        if (numMutualTowns > 1) {
            if (user?.isBot) {
                return `Installed in ${numMutualTowns} towns`
            }
            if (userId === myUserId) {
                return `Member of ${numMutualTowns} towns`
            }
            return `${numMutualTowns} mutual towns`
        } else if (mutualTowns && numMutualTowns === 1) {
            if (user?.isBot) {
                return `Installed in ${mutualTowns[0]?.name}`
            }
            return `Member of ${mutualTowns[0]?.name}`
        } else {
            return ''
        }
    }, [numMutualTowns, user?.isBot, userId, myUserId, mutualTowns])

    const { openPanel } = usePanelActions()
    const onClickMutualTowns = useCallback(() => {
        openPanel('mutual-towns', { profileId: userId })
    }, [openPanel, userId])

    const hasMutualTowns = numMutualTowns > 0

    return {
        mutualTowns,
        showMoreNum,
        numMutualTowns,
        membersText,
        onClickMutualTowns,
        hasMutualTowns,
    }
}
